

















import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Hero: require('@/components/Public/Hero').default,
    Summary: require('./Summary').default,
    FacebookLink: require('@/components/FacebookLink').default
  }
})
export default class BlogOverview extends Vue {
  get articles() {
    return this.$store.state.prerender.blogArticles
  }

  mounted() {
    document.dispatchEvent(new Event('x-app-rendered'))
  }
}
